<template>
  <div id="count-container" class="light flex-grow">
    <div class="flex pagination">
      <div class="page-link page-first" :title="t('First Page')" :class="{'disabled': page === 1}"
           @click="setPage(1)">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M8.354 1.646a.5.5 0 0 1 0 .708L2.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
          <path fill-rule="evenodd" d="M12.354 1.646a.5.5 0 0 1 0 .708L6.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
        </svg>
      </div>

      <div class="page-link prev-page" :title="t('Previous Page')"
           :class="{'disabled': page === 1}" @click="page > 1 ? setPage(page-1) : null"></div>

      <div class="page-link page-number"
           :class="{'active': pageNumber === page}"
           v-for="pageNumber in pages.slice(page < 3 ? 0 : page - 3, page + 3)"
           v-bind:key="pageNumber"
           @click="setPage(pageNumber)">
        {{ pageNumber }}
      </div>

      <div class="page-link next-page" :title="t('Next Page')"
           :class="{'disabled': page === pages.length}"
           @click="page < pages.length ? setPage(page+1) : null"></div>

      <div class="page-link page-last" :title="t('Last Page')"
           :class="{'disabled': page === pages.length}"
           @click="setPage(pages.length)">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708z"/>
          <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708z"/>
        </svg>
      </div>

      <div class="page-info">
        {{ (page - 1) * perPage }}-{{ ((page - 1) * perPage) + displayedSourceMessages.length }} {{ t('of') }}
        {{ filteredSourceMessages.length }} {{ t('translations') }}
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapMutations, mapState} from 'vuex';

export default {
  data() {
    return {
      pages: [],
    };
  },
  computed: {
    ...mapState({
      page: state => state.page,
      perPage: state => state.perPage,
      filteredSourceMessages: state => state.filteredSourceMessages
    }),
    ...mapGetters({
      displayedSourceMessages: 'displayedSourceMessages'
    })
  },
  watch: {
    filteredSourceMessages: {
      handler() {
        this.setPages();
      },
      deep: true
    }
  },
  methods: {
    setPages() {
      let numberOfPages = Math.ceil(this.filteredSourceMessages.length / this.perPage);
      this.pages = [];
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
      if (this.page > this.pages.length && this.pages.length > 0) {
        this.setPage(this.pages.length);
      }
    },
    setPage(nb) {
      this.setPage(nb);
    },
    t(str) {
      return this.$craft.t('translations-admin', str);
    },
    ...mapMutations({
      setPage: 'setPage',
    }),
  }
};
</script>

<style lang="scss" scoped>
@import "~craftcms-sass/mixins";

.page-number.active {
  pointer-events: none;
  background: $grey200;
}
</style>
